export default ({ request }) => ({
  mrpMaterialPlanListApi(data = {}) {
    return request({
      url: "/factory/mrp/material/plan/list",
      method: "post",
      data,
    })
  },
  mrpMaterialPlanDetailApi(data = {}) {
    return request({
      url: "/factory/mrp/material/plan/detail",
      method: "post",
      data,
    })
  },
  mrpMaterialPlanDetailListApi(data = {}) {
    return request({
      url: "/factory/mrp/material/plan/detail/list",
      method: "post",
      data,
    })
  },
  mrpMaterialPlanScheduleListApi(data = {}) {
    return request({
      url: "/factory/mrp/material/plan/schedule/list",
      method: "post",
      data,
    })
  },
})
